import { jsx as p, jsxs as $, Fragment as S } from "react/jsx-runtime";
import { forwardRef as j } from "react";
function q(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var w = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var x;
function C() {
  return x || (x = 1, function(t) {
    (function() {
      var l = {}.hasOwnProperty;
      function a() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var n = arguments[e];
          n && (r = i(r, u.call(this, n)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var n in r)
          l.call(r, n) && r[n] && (e = i(e, this && this[n] || n));
        return e;
      }
      function i(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (a.default = a, t.exports = a) : window.classNames = a;
    })();
  }(w)), w.exports;
}
var M = C();
const N = /* @__PURE__ */ q(M), L = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, O = N.bind(L), y = "purpur-icon", B = "md", A = (t) => t.filter((l) => Object.keys(l).length >= 1).map((l) => `${l.name}="${l.value}"`).join(" "), H = ({ content: t = "", title: l } = {}) => {
  const a = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    l ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], u = l ? `<title>${l}</title>` : "";
  return `<svg ${A(a)}>${u}${t}</svg>`;
}, P = (t) => t.replace(/<(\/?)svg([^>]*)>/g, "").trim(), f = ({
  ["data-testid"]: t,
  svg: l,
  allyTitle: a,
  className: u,
  size: i = B,
  ...r
}) => {
  const e = H({
    content: P(l.svg),
    title: a
  }), n = O(u, y, `${y}--${i}`);
  return /* @__PURE__ */ p(
    "span",
    {
      className: n,
      "data-testid": t,
      dangerouslySetInnerHTML: { __html: e },
      ...r
    }
  );
};
f.displayName = "Icon";
const V = {
  name: "arrow-left",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 12a.9.9 0 0 1 .264-.636l5.5-5.5a.9.9 0 0 1 1.272 1.272L6.173 11.1H20a.9.9 0 0 1 0 1.8H6.173l3.963 3.964a.9.9 0 1 1-1.272 1.272l-5.5-5.5A.9.9 0 0 1 3.1 12Z" clip-rule="evenodd"/></svg>',
  keywords: ["arrow-left"],
  category: "utility"
}, Z = {
  name: "arrow-right",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M20.9 12a.9.9 0 0 1-.264.636l-5.5 5.5a.9.9 0 0 1-1.272-1.272l3.963-3.964H4a.9.9 0 0 1 0-1.8h13.827l-3.963-3.964a.9.9 0 1 1 1.272-1.272l5.5 5.5A.9.9 0 0 1 20.9 12Z" clip-rule="evenodd"/></svg>',
  keywords: ["arrow-right"],
  category: "utility"
}, I = {
  name: "external",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M15 3.4a.9.9 0 1 1 0-1.8h6.5a.9.9 0 0 1 .9.9V9a.9.9 0 1 1-1.8 0V4.673l-7.964 7.963a.9.9 0 1 1-1.272-1.272L19.327 3.4H15ZM1.6 5c0-1.05.85-1.9 1.9-1.9h6a.9.9 0 0 1 0 1.8h-6a.1.1 0 0 0-.1.1v15.5a.1.1 0 0 0 .1.1h16a.1.1 0 0 0 .1-.1V14a.9.9 0 1 1 1.8 0v6.5a1.9 1.9 0 0 1-1.9 1.9h-16a1.9 1.9 0 0 1-1.9-1.9V5Z" clip-rule="evenodd"/></svg>',
  keywords: ["external"],
  category: "media"
}, E = {
  name: "phone",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M5.341 2.228c.75-.622 1.73-.43 2.305.145l2.783 2.783a1.9 1.9 0 0 1 0 2.687L8.843 9.43a.1.1 0 0 0 0 .142l5.586 5.585a.1.1 0 0 0 .142 0l1.585-1.585a1.9 1.9 0 0 1 2.687 0l3.5 3.5c.343.342.698 1.023.31 1.742-.346.645-1.173 1.615-3.154 2.936-1.75 1.167-3.667 1.269-5.297.903-1.61-.361-3.015-1.192-3.839-2.016a.9.9 0 0 1 1.273-1.272c.573.572 1.669 1.242 2.96 1.532 1.27.285 2.656.188 3.905-.645 1.483-.989 2.137-1.68 2.418-2.06l-3.348-3.347a.1.1 0 0 0-.142 0l-1.586 1.585a1.9 1.9 0 0 1-2.687 0l-5.585-5.585a1.9 1.9 0 0 1 0-2.688l1.585-1.585a.1.1 0 0 0 0-.142L6.41 3.682c-.447.383-1.183 1.102-2.206 2.38-.878 1.097-1.14 2.08-1.127 2.951.013.898.323 1.758.732 2.59.24.488.733 1.079 1.551 1.88.561.549 1.227 1.152 2.002 1.854.344.312.71.644 1.098 1a.9.9 0 0 1-1.215 1.327c-.367-.336-.722-.658-1.061-.965a77.443 77.443 0 0 1-2.082-1.93c-.831-.813-1.523-1.586-1.909-2.372-.456-.93-.896-2.07-.916-3.356-.02-1.314.399-2.7 1.521-4.103 1.148-1.435 1.995-2.254 2.544-2.71Z" clip-rule="evenodd"/></svg>',
  keywords: ["phone"],
  category: "device"
};
function F(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var d = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var k;
function R() {
  return k || (k = 1, function(t) {
    (function() {
      var l = {}.hasOwnProperty;
      function a() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var n = arguments[e];
          n && (r = i(r, u.call(this, n)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var n in r)
          l.call(r, n) && r[n] && (e = i(e, this && this[n] || n));
        return e;
      }
      function i(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (a.default = a, t.exports = a) : window.classNames = a;
    })();
  }(d)), d.exports;
}
var T = R();
const z = /* @__PURE__ */ F(T), D = {
  "purpur-cta-link": "_purpur-cta-link_1e75l_1",
  "purpur-cta-link--xs": "_purpur-cta-link--xs_1e75l_33",
  "purpur-cta-link--icon-only": "_purpur-cta-link--icon-only_1e75l_36",
  "purpur-cta-link--sm": "_purpur-cta-link--sm_1e75l_39",
  "purpur-cta-link--md": "_purpur-cta-link--md_1e75l_45",
  "purpur-cta-link--lg": "_purpur-cta-link--lg_1e75l_51",
  "purpur-cta-link--full-width": "_purpur-cta-link--full-width_1e75l_57",
  "purpur-cta-link--primary": "_purpur-cta-link--primary_1e75l_60",
  "purpur-cta-link--disabled": "_purpur-cta-link--disabled_1e75l_64",
  "purpur-cta-link--primary-negative": "_purpur-cta-link--primary-negative_1e75l_70",
  "purpur-cta-link--secondary": "_purpur-cta-link--secondary_1e75l_82",
  "purpur-cta-link--secondary-negative": "_purpur-cta-link--secondary-negative_1e75l_93",
  "purpur-cta-link--expressive": "_purpur-cta-link--expressive_1e75l_104",
  "purpur-cta-link--expressive-negative": "_purpur-cta-link--expressive-negative_1e75l_114"
}, W = z.bind(D), s = "purpur-cta-link", U = ["forward", "external", "back", "phone"], G = {
  forward: Z,
  external: I,
  back: V,
  phone: E
}, J = j(
  ({
    children: t,
    className: l,
    ["data-testid"]: a,
    fullWidth: u = !1,
    iconOnly: i = !1,
    showIcon: r = !0,
    negative: e = !1,
    size: n = "md",
    variant: v,
    icon: o = "forward",
    ...c
  }, _) => {
    const b = W(
      [
        l,
        s,
        `${s}--${e ? `${v}-negative` : v}`,
        `${s}--${n}`
      ],
      {
        [`${s}--icon-only`]: i,
        [`${s}--negative`]: e,
        [`${s}--full-width`]: u
      }
    ), g = G[o], m = /* @__PURE__ */ $(S, { children: [
      r && (o === "back" || o === "phone") && /* @__PURE__ */ p(f, { svg: g, size: n === "lg" ? "sm" : "xs" }),
      (!i || i && !r) && t,
      r && (o === "forward" || o === "external") && /* @__PURE__ */ p(f, { svg: g, size: n === "lg" ? "sm" : "xs" })
    ] }), h = {
      ...c,
      className: b,
      "data-testid": a
    };
    return "href" in c && c.href ? /* @__PURE__ */ p("a", { ...h, ref: _, children: m }) : /* @__PURE__ */ p("span", { ...h, ref: _, children: m });
  }
);
J.displayName = "CtaLink";
export {
  J as CtaLink,
  U as ctaLinkIcons
};
//# sourceMappingURL=cta-link.es.js.map
